import React, { Component } from "react";
import { connect } from "react-redux";
import AddTrackedKeywords from "../../components/TrackedKeywords/AddTrackedKeywords";
import { addTrackedKeywordsAndCheckStatus } from "../../store/tracked_keywords/operations";
import { isAddingTrackedKeywords } from "../../store/tracked_keywords/selectors";

class AddKeywords extends Component {
  render() {
    return (
      <AddTrackedKeywords
        domain={this.props.domain}
        seoDb={this.props.seoDb}
        isAddingTrackedKeywords={this.props.isAddingTrackedKeywords}
        addTrackedKeywords={(domain, seoDb, keywords) =>
          this.props.addTrackedKeywordsAndCheckStatus(domain, seoDb, keywords)
        }
        sendKeywords={this.getKeywords}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isAddingTrackedKeywords: isAddingTrackedKeywords(state),
});

export default connect(mapStateToProps, {
  addTrackedKeywordsAndCheckStatus,
})(AddKeywords);
